import React, { useState } from 'react';
import { Search, X } from 'lucide-react';
import { money, monthTx } from './financeUtils';

export const TransactionsTable = ({ tx, view, onDelete }) => {
  const [q, setQ] = useState('');
  const rows = monthTx(tx, view)
    .filter((t) => !q || `${t.description} ${t.category} ${t.note || ''}`.toLowerCase().includes(q.trim().toLowerCase()))
    .sort((a, b) => b.date.localeCompare(a.date) || String(b.created_at).localeCompare(String(a.created_at)));
  return (
    <section className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4" id="transacoes" data-testid="finance-transactions">
      <h3 className="font-semibold text-slate-900 text-sm mb-2">Movimentações do mês</h3>
      <div className="relative mb-2">
        <Search className="w-4 h-4 absolute left-2.5 top-2.5 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar movimentação..."
          className="w-full pl-8 pr-3 py-2 border border-slate-200 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-emerald-200" data-testid="finance-search" />
      </div>
      <div className="divide-y divide-slate-100">
        {rows.length === 0 && (
          <p className="text-center text-xs text-slate-500 py-8" data-testid="finance-empty">
            {q ? 'Nenhum resultado para essa busca.' : 'Nenhuma movimentação neste mês. Toque em “Nova” para começar.'}
          </p>
        )}
        {rows.map((t) => (
          <div key={t.id} className="flex items-center gap-2 py-2.5" data-testid={`finance-tx-${t.id}`}>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-slate-800 truncate">{t.description}</p>
              <p className="text-[10px] text-slate-400 truncate">
                <span className="bg-slate-100 text-slate-600 rounded-full px-1.5 py-0.5 mr-1">{t.category}</span>
                {t.date.slice(8, 10)}/{t.date.slice(5, 7)}{t.note ? ` · ${t.note}` : ''}
              </p>
            </div>
            <span className={`text-xs font-bold whitespace-nowrap ${t.type === 'income' ? 'text-emerald-700' : 'text-red-600'}`}>
              {t.type === 'income' ? '+' : '−'} {money(t.amount)}
            </span>
            <button type="button" onClick={() => onDelete(t)} aria-label={`Excluir ${t.description}`} className="p-1.5 rounded-lg text-slate-400 hover:bg-red-50 hover:text-red-600" data-testid={`finance-delete-${t.id}`}>
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
